import React from "react";
import { Footer } from "../components";
import { Business } from "../components";

export function FooterContainer(props) {
  return (
    <Footer>
      <Footer.ButtonLink
        to='/privacy'
        // onClick={() => window.location.pathname='/Privacy'}
      >
        Privacy Policy
      </Footer.ButtonLink>
      <Footer.Text>
        <span>
          <img src='/images/icons/Vector (10).png' alt='abc' />
        </span>
        Bits QA 2023
      </Footer.Text>
      <Business.Button
        onClick={() => {
          window.location.assign(
            "https://apps.apple.com/us/app/vms-manage-visitors/id1493484227/"
          );
        }}>
        <Business.ButtonContainer>
          <Business.ButtonDiv>
            <img src='/images/icons/_Group_.png' alt='abc' />
          </Business.ButtonDiv>

          <div>
            <Business.ButtonHead> Download on the </Business.ButtonHead>
            <Business.ButtonBase>App Store</Business.ButtonBase>
          </div>
        </Business.ButtonContainer>
      </Business.Button>

      <Footer.Text>
        info@bitechqa.com
        <Footer.SubText>
          Address: ALMUFTAH PLAZA, ALRAYYAN RD, DOHA,QATAR
        </Footer.SubText>
      </Footer.Text>
    </Footer>
  );
}
